import { useEffect } from 'react';
import { Building2, Compass, User } from 'lucide-react';
import { useEntityPeek, type PeekKind } from './entityPeekStore';

const KIND_META: Record<PeekKind, { label: string; icon: typeof Building2 }> = {
  company: { label: 'Empresa', icon: Building2 },
  originator: { label: 'Originadora', icon: Compass },
  person: { label: 'Pessoa', icon: User },
};

/**
 * Modal read-only de Empresa/Originadora/Pessoa aberto pela busca global (E7). Mínimo por ora —
 * a ficha completa dessas entidades é Onda 2. Esc fecha.
 */
export function EntityPeekModal() {
  const entity = useEntityPeek((s) => s.entity);
  const close = useEntityPeek((s) => s.close);

  useEffect(() => {
    if (!entity) return undefined;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [entity, close]);

  if (!entity) return null;
  const meta = KIND_META[entity.kind];
  const Icon = meta.icon;

  return (
    <>
      <button
        type="button"
        aria-label="Fechar"
        onClick={close}
        className="fixed inset-0 z-[70] cursor-default bg-[rgba(20,18,12,0.45)]"
      />
      <div
        role="dialog"
        aria-label={`${meta.label}: ${entity.name}`}
        className="fixed left-1/2 top-1/2 z-[80] w-[min(420px,92vw)] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-vega-surface p-5 shadow-vega-lg"
      >
        <div className="mb-2 flex items-center gap-2">
          <Icon size={16} className="text-vega-muted" />
          <span className="text-[11px] font-medium uppercase tracking-wide text-vega-muted">{meta.label}</span>
        </div>
        <h2 className="text-[17px] font-semibold tracking-tight text-vega-ink">{entity.name}</h2>
        {entity.secondary && <p className="mt-1 text-[12.5px] text-vega-muted">{entity.secondary}</p>}
        <p className="mt-4 text-[11.5px] text-vega-muted-2">A ficha completa desta entidade chega em breve.</p>
        <div className="mt-4 flex justify-end">
          <button
            type="button"
            onClick={close}
            className="rounded border border-vega-line px-3 py-1.5 text-[12.5px] font-medium text-vega-muted"
          >
            Fechar
          </button>
        </div>
      </div>
    </>
  );
}
